<template>
  <div>
    <b-modal
      ref="modal"
      scrollable
      size="lg"
      hide-footer
      hide-header
      @show="carregar"
    >
      <div style="padding: 24px">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="m-0">Timeline - 24h · {{ contaNome }}</h4>
          <b-button variant="link" class="p-0" @click="$refs.modal.hide()">
            <i class="fas fa-times fa-lg" style="color: #b5b5c3"></i>
          </b-button>
        </div>

        <v-overlay :value="carregando" :absolute="true">
          <v-progress-circular indeterminate size="32" color="#462181" width="2"
            ><v-progress-circular
              indeterminate
              size="24"
              color="#ff7f00"
              width="2"
              rotate="180"
            ></v-progress-circular
          ></v-progress-circular>
        </v-overlay>

        <TimelineCampanhas
          titulo=""
          :lista="lista"
          :carregando="carregando"
          timelineHeight="65vh"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import TimelineCampanhas from "../../dashboard/TimelineCampanhas.vue";

export default {
  components: { TimelineCampanhas },
  data() {
    return {
      contaId: null,
      contaNome: "",
      carregando: false,
      lista: []
    };
  },
  methods: {
    abrir(contaId, contaNome) {
      this.contaId = contaId;
      this.contaNome = contaNome || "";
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },

    carregar() {
      if (!this.contaId) return;

      this.carregando = true;
      this.lista = [];
      ApiService.get(`central-contas/${this.contaId}/timeline`, "", false)
        .then((response) => {
          const dados = response.data.data;
          if (dados) {
            this.lista = dados.timeline || [];
          }
        })
        .finally(() => {
          this.carregando = false;
        });
    }
  }
};
</script>
